import Fade from "react-reveal";
import { Container, Form } from "reactstrap";

import "rsuite/dist/rsuite.min.css";

// images
import CustomPagination from "Component/common/CustomPagination";
import SearchFilter from "Component/common/SearchFilter";
import TableActions from "Component/common/TableActions";
import TableLayout from "Component/common/TableLayout";
import TableProfile from "Component/common/TableLayout/TableProfile";
import TableStatusOptionsAction from "Component/common/TableStatusOptionsAction";
import dataHandler from "hooks/dataHandler";
import usePermissions from "hooks/usePermissions";
import { MANAGE_POSTS, POST_LIST } from "services/ApiCalls";
import { commonStatusOptions } from "utilities/const";
import { PERMISSION_KEYS } from "utilities/permissionConst";
import { truncateString } from "utilities/utilities";

const PendingPosts = () => {
  const {
    body,
    deleteHandler,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    statusChangeHandler,
    total,
    loader,
    setBody,
    data,
    refetch,
  } = dataHandler({
    api: POST_LIST,
    dataToSet: (data) => data?.data,
    extraBody: {
      status: 0,
      startDate: "",
      endDate: "",
    },
    dependencies: ["endDate"],
  });

  const permission = usePermissions({
    permissionKey: PERMISSION_KEYS.PENDING_POSTS,
  });

  const col = [
    {
      head: "Banner Image",
      accessor: "email",
      component: (item) => (
        <TableProfile image={item?.uploads?.[0] && item?.uploads[0]?.link} />
      ),
    },
    {
      head: "User Name",
      accessor: "",
      component: (item) => (
        <>{(item?.userId?.fname || "-") + " " + (item?.userId?.lname || "-")}</>
      ),
    },
    {
      head: "Name",
      accessor: "",
      component: (item) => <>{item?.name ? item?.name : "-"}</>,
    },
    {
      head: "Description",
      accessor: "description",
      component: (item) => <>{truncateString(item?.description, 15)}</>,
    },
  ];

  if (permission.isAdd) {
    col.push({
      head: "Status",
      accessor: "accountType",
      component: (item, index) => (
        <TableStatusOptionsAction
          onChange={(userStatus, reason) => {
            statusChangeHandler(
              () =>
                MANAGE_POSTS(
                  reason
                    ? { ...reason, _id: item?._id, status: +userStatus }
                    : { _id: item?._id, status: +userStatus },
                ),
              index,
              "status",
              +userStatus,
              true,
            );
          }}
          statusOptionArr={commonStatusOptions}
          value={item?.status}
          showRejectModel={true}
        />
      ),
    });
  }

  if (permission.isView) {
    col.push({
      head: "Action",
      accessor: "",
      component: (item) => (
        <>
          <TableActions viewLink={`/view-post/${item?._id}`} />
        </>
      ),
    });
  }
  return (
    <Fade>
      <section className="dashboard_first comon_dashpad">
        <Form>
          <div className="comom_fillter_set text-start">
            <h3 className="fillter_head">Manage Post Requests</h3>

            <div className="fillter_form_wrap d-flex align-items-center gap-3 mt-4">
              <div className="fillter_area d-flex">
                <div className="fillter_by d-flex align-items-center gap-3">
                  <h5>Filter by :</h5>
                  <div className="search_form d-flex align-items-end gap-3">
                    <SearchFilter body={body} setBody={setBody} />

                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>

        <div className="user_tabbingset mt-5">
          <section className="tabbing_common">
            <div className="tab-frame user_frame">
            
              <div className="pending_user_content mt-4">
                <section className="Diagnosis_table com_table ">
                  <Container>
                    <TableLayout
                      data={data}
                      column={col}
                      loader={loader}
                      body={body}
                    />
                    <div className="pagination_list d-flex align-items-center gap-3 justify-content-end py-3">
                      <CustomPagination
                        total={total}
                        body={body}
                        setBody={setBody}
                        pageChangeHandler={paginationHandler}
                      />
                    </div>
                  </Container>
                </section>
              </div>
            
            </div>
          </section>
        </div>
      </section>
    </Fade>
  );
};

export default PendingPosts;
